import { dragPopupComCreate } from '@/utils/js/leaflet/dragPopup.js';
import PreAnnotationPolyInfo from '../components/PreAnnotationPolyInfo/index.vue';

const popupCache = new Map(); // 用 Map 缓存 target id -> popup 实例，便于遍历销毁
let activeDragPopup = null;

/**
 * 展示/切换 工作台数据的可拖拽悬浮窗
 */
export const showPreAnnotationDragPopup = (map, target, latlng, layer) => {
  const targetKey = target.id || target;

  // 1. 同一个目标 → toggle 显隐
  if (activeDragPopup && activeDragPopup.targetKey === targetKey) {
    if (map.hasLayer(activeDragPopup.group)) {
      activeDragPopup.group.remove();
    } else {
      activeDragPopup.updateStartLatLng && activeDragPopup.updateStartLatLng(latlng);
      activeDragPopup.group.addTo(map);
    }
    return;
  }

  // 2. 隐藏当前正在显示的其他目标
  if (activeDragPopup && activeDragPopup.group) {
    activeDragPopup.group.remove();
    activeDragPopup = null;
  }

  // 3. 已初始化过 → 直接复用
  const existing = popupCache.get(targetKey);
  if (existing) {
    activeDragPopup = existing;
    activeDragPopup.updateStartLatLng && activeDragPopup.updateStartLatLng(latlng);
    activeDragPopup.group.addTo(map);
    return;
  }

  // 4. 首次初始化
  const endLatlng = L.latLng({ lat: latlng.lat + 0.05, lng: (latlng.lng || latlng.lon) + 0.05 });
  const { app, group, updateStartLatLng } = dragPopupComCreate(latlng, {
    className: 'custom-drag-popup',
    iconSize: [0, 0]
  }, {
    endLatlng
  })(PreAnnotationPolyInfo, { target, layer });

  group.addTo(map);
  const popupObj = { app, group, targetKey, updateStartLatLng };
  popupCache.set(targetKey, popupObj);
  activeDragPopup = popupObj;
}

/**
 * 隐藏当前弹窗（不销毁）
 */
export const clearPreAnnotationPopup = () => {
  if (activeDragPopup) {
    if (activeDragPopup.group) {
      activeDragPopup.group.remove();
    }
    activeDragPopup = null;
  }
}

/**
 * 彻底销毁所有已缓存的弹窗实例（含 Vue App unmount）
 * 在预标注图层被整体移除时调用
 */
export const destroyAllPopups = () => {
  popupCache.forEach((popup) => {
    if (popup.group) popup.group.remove();
    if (popup.app) popup.app.unmount();
  });
  popupCache.clear();
  activeDragPopup = null;
}
